import {Fragment} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SaveDialog from "./SaveDialog";
import {useBoolState} from "../../../../../hooks";
import {ClientDevice} from "../../../../../api";
import {SaveClientDeviceMutationVariables} from "../../queries.generated";
import {defineMessage} from "react-intl";

type Props = {
    device: ClientDevice;
    onSuccess: () => void;
};

export default ({onSuccess, device}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const initialData: SaveClientDeviceMutationVariables = {
        id: device.id,
        description: device.description ?? "",
    };

    return (
        <Fragment>
            <IconButton color="primary" size="small" onClick={open}>
                <FontAwesomeIcon icon="pencil-alt" />
            </IconButton>
            <SaveDialog
                isOpen={isOpen}
                close={close}
                title={defineMessage({id: "devices.client.update", defaultMessage: "Update client device: {name}"})}
                titleVariables={{name: device.description}}
                initialData={initialData}
                onSuccess={onSuccess}
                cacheKeyPostfix={`update_${device.id}`}
            />
        </Fragment>
    );
};
